<template>
  <div style="background: white; height: 100%">
    <div>
      <div class="heaer-text">细分维度报表</div>
      <div class="table-wrap">
        <summary-filter
          @showLoading="showLoading"
          @showLtvLoading="showLtvLoading"
          @changeColumn="changeColumn"
          @downloadFile="downloadFile"
          @refreshTable="refreshTable"
          :showview="showview"
          @changeshowview="changeshowview"
          @reflashchart="reflashchart"
        ></summary-filter>
        <summary-table
          v-if="showview == 0 && deleteRoI !== '4'"
          ref="usertable"
          :column="column"
          :list="list"
          :loading="loading"
          :ltvLoading="ltvLoading"
          :deleteRoI="deleteRoI"
        ></summary-table>

        <camp-summary-table
          v-if="showview == 0 && deleteRoI == '4'"
          ref="usertable"
          :column="column"
          :list="list"
          :loading="loading"
          :deleteRoI="deleteRoI"
        ></camp-summary-table>
        <normal-charts
          v-if="showview == 1"
          :datelist="datelist"
          :naturallegend="naturallegend"
          :arpulegend="arpulegend"
          :roilegend="roilegend"
          :retenlegend="retenlegend"
          :naturalseriesList="naturalseriesList"
          :arpuseriesList="arpuseriesList"
          :roiseriesList="roiseriesList"
          :retenseriesList="retenseriesList"
          :showwhichchart="deleteRoI"
          :countryseriesList="countryseriesList"
          :countryxAxis="countryxAxis"
          :countrylegend="countrylegend"
          :chnlseriesList="chnlseriesList"
          :chnllegend="chnllegend"
          :chnlxAxis="chnlxAxis"
          :recoveryseriesList="recoveryseriesList"
          :recoverylegend="recoverylegend"
          :toDayROIseriesList="toDayROIseriesList"
          :toDayROIlegend="toDayROIlegend"
          :currAlllegend="currAlllegend"
          :currAllseriesList="currAllseriesList"
          :inPurchlegend="inPurchlegend"
          :inPurchSeriesList="inPurchSeriesList"
          ref="normalchartsref"
        ></normal-charts>
        <custom-charts
          v-if="showview == 2"
          :column="column"
          :customX="customX"
          :listsortbycountry="listsortbycountry"
          :listsortbyincome="listsortbyincome"
          :list="list"
          :deleteRoI="deleteRoI"
        ></custom-charts>
      </div>
    </div>
  </div>
</template>
<script>
import CustomCharts from "./customcharts";
import { filterarray } from "../../utils/tool";
import NormalCharts from "./normalcharts";
import SummaryFilter from "./summaryFilter";
import SummaryTable from "./summaryTable";
import CampSummaryTable from "./campSummaryTable.vue";
import {
  summary_date_table_column,
  summary_country_table_column,
  summary_medio_table_column,
  summary_camp_table_column,
} from "../../config/table_comlun";
export default {
  name: "summaryrecord",
  components: {
    SummaryFilter,
    SummaryTable,
    NormalCharts,
    CustomCharts,
    CampSummaryTable,
  },
  data() {
    return {
      loading: false,
      ltvLoading: false,
      column: summary_date_table_column,
      deleteRoI: "1",
      totalColumn: [],
      showview: 0,
      naturallegend: ["推广新增", "自然新增", "自然量占比"],
      arpulegend: ["活跃arpu", "总新增"],
      // roilegend: ["活跃arpu", "推广单价"],
      roilegend: ["新增roi", "推广roi", "推广单价"],
      retenlegend: ["day1留存", "day3留存", "day7留存", "day30留存", "总新增"],
      countrylegend: ["新增roi", "推广roi", "总新增"],
      chnllegend: ["新增roi", "推广roi", "总新增"],
      recoverylegend: ["变现收入", "推广总计", "当前变现ROI"],
      toDayROIlegend: ["当前ROI", "活跃新增比"],
      currAlllegend: ["收入总计", "推广总计", "当前ROI"],
      inPurchlegend: ["内购收入", "内购收入占比"],
      // customlist: [],
    };
  },
  // mounted() {
  //   let param = {
  //     order: "asc",
  //     offset: 0,
  //   };
  //   this.$store.dispatch("getProductTableList", {
  //     param,
  //     cb: () => {},
  //   });
  // },
  computed: {
    list: function () {
      return this.$store.state.Summary.summaryList;
    },
    datelist: function () {
      return filterarray(this.list, "date");
    },
    naturalseriesList: function () {
      let arr = [];
      let barnum = 0;
      let linenum = 0;
      [
        { popuIncre: "推广新增" },
        { orgIncre: "自然新增" },
        { orgPercent: "自然量占比" },
      ].forEach((item, index) => {
        let barlineindex = index == 2 ? linenum : barnum;
        var colorList =
          index == 2
            ? ["#00B050", "#7030A0", "#C0504D", "#31859C", "#87A0BE", "#FFD966"]
            : [
                "#87A0BE",
                "#FFD966",
                "#31859C",
                "#C0504D",
                "#7030A0",
                "#00B050",
              ];
        arr.push({
          name: Object.values(item).join(),
          type: index == 2 ? "line" : "bar",
          smooth: false,
          symbol: "circle",
          symbolSize: 5,
          showSymbol: false,
          lineStyle: {
            normal: {
              width: 2,
            },
          },
          itemStyle: {
            // opacity: 0.7,
            color: colorList[barlineindex],
          },
          data: filterarray(this.list, Object.keys(item)),
          yAxisIndex: index == 2 ? 1 : 0,
        });
        if (index == 2) {
          linenum++;
        } else {
          barnum++;
        }
      });
      return arr;
    },
    roiseriesList: function () {
      let arr = [];
      // [{ arpu: "活跃arpu" }, { popCost: "推广单价" }]
      let barnum = 0;
      let linenum = 0;
      [
        { increRoi: "新增roi" },
        { popuRoi: "推广roi" },
        { popCost: "推广单价" },
      ].forEach((item, index) => {
        let barlineindex = item == 0 || index == 1 ? linenum : barnum;
        var colorList =
          index == 0 || index == 1
            ? ["#00B050", "#7030A0", "#C0504D", "#31859C", "#87A0BE", "#FFD966"]
            : [
                "#87A0BE",
                "#FFD966",
                "#31859C",
                "#C0504D",
                "#7030A0",
                "#00B050",
              ];
        arr.push({
          name: Object.values(item).join(),
          type: index == 0 || index == 1 ? "line" : "bar",
          smooth: false,
          symbol: "circle",
          symbolSize: 5,
          showSymbol: false,
          lineStyle: {
            normal: {
              width: 2,
            },
          },
          itemStyle: {
            // opacity: 0.7,
            color: colorList[barlineindex],
          },
          data: filterarray(this.list, Object.keys(item)),
          yAxisIndex: index == 0 || index == 1 ? 0 : 1,
        });
        if (index == 0 || index == 1) {
          linenum++;
        } else {
          barnum++;
        }
      });
      return arr;
    },
    arpuseriesList: function () {
      let arr = [];
      let barnum = 0;
      let linenum = 0;
      [{ arpu: "活跃arpu" }, { totalIncre: "总新增" }].forEach(
        (item, index) => {
          let barlineindex = item.percent ? linenum : barnum;
          var colorList =
            index == 0
              ? [
                  "#00B050",
                  "#7030A0",
                  "#C0504D",
                  "#31859C",
                  "#87A0BE",
                  "#FFD966",
                ]
              : [
                  "#87A0BE",
                  "#FFD966",
                  "#31859C",
                  "#C0504D",
                  "#7030A0",
                  "#00B050",
                ];
          arr.push({
            name: Object.values(item).join(),
            type: index == 0 ? "line" : "bar",
            smooth: false,
            symbol: "circle",
            symbolSize: 5,
            showSymbol: false,
            lineStyle: {
              normal: {
                width: 2,
              },
            },
            itemStyle: {
              // opacity: 0.7,
              color: colorList[barlineindex],
            },
            data: filterarray(this.list, Object.keys(item)),
            yAxisIndex: index == 0 ? 0 : 1,
          });
          if (index == 0) {
            linenum++;
          } else {
            barnum++;
          }
        }
      );
      return arr;
    },
    retenseriesList: function () {
      let arr = [];
      let barnum = 0;
      let linenum = 0;

      [
        // { reten1: "day1留存" },
        // { reten3: "day3留存" },
        // { reten7: "day7留存" },
        // { reten30: "day30留存" },
        // { totalIncre: "总新增" },
        { retenRate1: "day1留存" },
        { retenRate3: "day3留存" },
        { retenRate7: "day7留存" },
        { retenRate30: "day30留存" },
        { totalIncre: "总新增" },
      ].forEach((item, index) => {
        let barlineindex = index !== 4 ? linenum : barnum;
        var colorList =
          index !== 4
            ? ["#00B050", "#7030A0", "#C0504D", "#31859C", "#87A0BE", "#FFD966"]
            : [
                "#87A0BE",
                "#FFD966",
                "#31859C",
                "#C0504D",
                "#7030A0",
                "#00B050",
              ];
        arr.push({
          name: Object.values(item).join(),
          type: index == 4 ? "bar" : "line",
          smooth: false,
          symbol: "circle",
          symbolSize: 5,
          showSymbol: false,
          lineStyle: {
            normal: {
              width: 2,
            },
          },
          itemStyle: {
            // opacity: 0.7,
            color: colorList[barlineindex],
          },
          data: filterarray(this.list, Object.keys(item)),
          yAxisIndex: index == 4 ? 1 : 0,
        });
        if (index !== 4) {
          linenum++;
        } else {
          barnum++;
        }
      });
      return arr;
    },
    recoveryseriesList: function () {
      let arr = [];
      let barnum = 0;
      let linenum = 0;

      [
        { incomeTotalUSD: "变现收入" },
        { popTotalUSD: "推广总计" },
        { currentRoi: "当前变现ROI" },
      ].forEach((item, index) => {
        let barlineindex = index == 2 ? linenum : barnum;
        var colorList =
          index == 2
            ? ["#00B050", "#7030A0", "#C0504D", "#31859C", "#87A0BE", "#FFD966"]
            : [
                "#87A0BE",
                "#FFD966",
                "#31859C",
                "#C0504D",
                "#7030A0",
                "#00B050",
              ];
        arr.push({
          name: Object.values(item).join(),
          type: index == 0 || index == 1 ? "bar" : "line",
          smooth: false,
          symbol: "circle",
          symbolSize: 5,
          showSymbol: false,
          lineStyle: {
            normal: {
              width: 2,
            },
          },
          itemStyle: {
            color: colorList[barlineindex],
          },
          data: filterarray(this.list, Object.keys(item)),
          yAxisIndex: index == 2 ? 1 : 0,
        });
        if (index !== 2) {
          barnum++;
        } else {
          linenum++;
        }
      });
      return arr;
    },
    toDayROIseriesList: function () {
      let arr = [];
      let linenum = 0;

      [{ toDayROI: "当前ROI" }, { activePecent: "活跃新增比" }].forEach(
        (item, index) => {
          let barlineindex = linenum;
          var colorList = [
            "#00B050",
            "#7030A0",
            "#C0504D",
            "#31859C",
            "#87A0BE",
            "#FFD966",
          ];

          arr.push({
            name: Object.values(item).join(),
            type: "line",
            smooth: false,
            symbol: "circle",
            symbolSize: 5,
            showSymbol: false,
            lineStyle: {
              normal: {
                width: 2,
              },
            },
            aaa: "111",
            itemStyle: {
              color: colorList[barlineindex],
            },
            data: filterarray(this.list, Object.keys(item)),
            yAxisIndex: index == 1 ? 1 : 0,
          });

          linenum++;
        }
      );
      return arr;
    },
    currAllseriesList: function () {
      let arr = [];
      let barnum = 0;
      let linenum = 0;

      [
        { allTotalIncome: "收入总计" },
        { popTotalUSD: "推广总计" },
        { toDayROI: "当前ROI" },
      ].forEach((item, index) => {
        let barlineindex = index == 2 ? linenum : barnum;
        var colorList =
          index == 2
            ? ["#00B050", "#7030A0", "#C0504D", "#31859C", "#87A0BE", "#FFD966"]
            : [
                "#87A0BE",
                "#FFD966",
                "#31859C",
                "#C0504D",
                "#7030A0",
                "#00B050",
              ];
        arr.push({
          name: Object.values(item).join(),
          type: index == 0 || index == 1 ? "bar" : "line",
          smooth: false,
          symbol: "circle",
          symbolSize: 5,
          showSymbol: false,
          lineStyle: {
            normal: {
              width: 2,
            },
          },
          itemStyle: {
            color: colorList[barlineindex],
          },
          data: filterarray(this.list, Object.keys(item)),
          yAxisIndex: index == 2 ? 1 : 0,
        });
        if (index !== 2) {
          barnum++;
        } else {
          linenum++;
        }
      });
      return arr;
    },
    inPurchSeriesList: function () {
      let arr = [];
      let linenum = 0;
      [{ payIncome: "内购收入" }, { payPerAdsRate: "内购收入占比" }].forEach(
        (item, index) => {
          let barlineindex = linenum;
          var colorList =
            index == 2
              ? [
                  "#00B050",
                  "#7030A0",
                  "#C0504D",
                  "#31859C",
                  "#87A0BE",
                  "#FFD966",
                ]
              : [
                  "#87A0BE",
                  "#FFD966",
                  "#31859C",
                  "#C0504D",
                  "#7030A0",
                  "#00B050",
                ];
          arr.push({
            name: Object.values(item).join(),
            type: index == 0 ? "bar" : "line",
            smooth: false,
            symbol: "circle",
            symbolSize: 5,
            showSymbol: false,
            lineStyle: {
              normal: {
                width: 2,
              },
            },
            itemStyle: {
              color: colorList[barlineindex],
            },
            data: filterarray(this.list, Object.keys(item)),
            yAxisIndex: index == 1 ? 1 : 0,
          });
          linenum++;
        }
      );
      return arr;
    },
    listsortbycountry: function () {
      let arr = this.list.slice();
      arr.sort((a, b) => {
        if (!a["incomeTotalUSD"] && !b["incomeTotalUSD"]) {
          return 0;
        } else if (!a["incomeTotalUSD"] && b["incomeTotalUSD"]) {
          return 1;
        } else if (a["incomeTotalUSD"] && !b["incomeTotalUSD"]) {
          return -1;
        }
        return a["incomeTotalUSD"] - b["incomeTotalUSD"] <= 0 ? 1 : -1;
      });

      let arr1 = [];
      if (arr.length > 20) {
        arr1 = arr.slice(0, 20);
      } else {
        arr1 = arr;
      }
      return arr1;
    },
    countryxAxis: function () {
      return filterarray(this.listsortbycountry, "geo");
    },
    countryseriesList: function () {
      let arr = [];
      let barnum = 0;
      let linenum = 0;
      [
        { increRoi: "新增roi" },
        { popuRoi: "推广roi" },
        { totalIncre: "总新增" },
      ].forEach((item, index) => {
        let barlineindex = index !== 2 ? linenum : barnum;
        var colorList =
          index !== 2
            ? ["#00B050", "#7030A0", "#C0504D", "#31859C", "#87A0BE", "#FFD966"]
            : [
                "#87A0BE",
                "#FFD966",
                "#31859C",
                "#C0504D",
                "#7030A0",
                "#00B050",
              ];
        arr.push({
          name: Object.values(item).join(),
          type: index == 2 ? "bar" : "line",
          smooth: false,
          symbol: "circle",
          symbolSize: 5,
          showSymbol: false,
          lineStyle: {
            normal: {
              width: 2,
            },
          },
          itemStyle: {
            // opacity: 0.7,
            color: colorList[barlineindex],
          },
          data: filterarray(this.listsortbycountry, Object.keys(item)),
          yAxisIndex: index == 2 ? 1 : 0,
          markLine:
            index !== 2
              ? {
                  silent: true,
                  label: { show: false },
                  symbol: "none",
                  lineStyle: { color: "red", type: "dashed" },
                  data: [
                    {
                      yAxis: 100,
                    },
                  ],
                }
              : {},
        });
        if (index !== 2) {
          linenum++;
        } else {
          barnum++;
        }
      });
      return arr;
    },
    listsortbyincome: function () {
      let arr = this.list.slice();
      arr.sort((a, b) => {
        if (!a["totalIncre"] && !b["totalIncre"]) {
          return 0;
        } else if (!a["totalIncre"] && b["totalIncre"]) {
          return 1;
        } else if (a["totalIncre"] && !b["totalIncre"]) {
          return -1;
        }
        return a["totalIncre"] - b["totalIncre"] <= 0 ? 1 : -1;
      });
      return arr;
    },
    chnlxAxis: function () {
      if (this.deleteRoI == "4") {
        return filterarray(this.listsortbyincome, "campaign");
      } else {
        return filterarray(this.listsortbyincome, "mediaSource");
      }
    },
    chnlseriesList: function () {
      let arr = [];
      let barnum = 0;
      let linenum = 0;
      [
        { increRoi: "新增roi" },
        { popuRoi: "推广roi" },
        { totalIncre: "总新增" },
      ].forEach((item, index) => {
        let barlineindex = index !== 2 ? linenum : barnum;
        var colorList =
          index !== 2
            ? ["#00B050", "#7030A0", "#C0504D", "#31859C", "#87A0BE", "#FFD966"]
            : [
                "#87A0BE",
                "#FFD966",
                "#31859C",
                "#C0504D",
                "#7030A0",
                "#00B050",
              ];
        arr.push({
          name: Object.values(item).join(),
          type: index == 2 ? "bar" : "line",
          smooth: false,
          symbol: "circle",
          symbolSize: 5,
          showSymbol: false,
          lineStyle: {
            normal: {
              width: 2,
            },
          },
          itemStyle: {
            // opacity: 0.7,
            color: colorList[barlineindex],
          },
          data: filterarray(this.listsortbyincome, Object.keys(item)),
          yAxisIndex: index == 2 ? 1 : 0,
          markLine:
            index !== 2
              ? {
                  silent: true,
                  label: { show: false },
                  symbol: "none",
                  lineStyle: { color: "red", type: "dashed" },
                  data: [
                    {
                      yAxis: 100,
                    },
                  ],
                }
              : {},
        });
        if (index !== 2) {
          linenum++;
        } else {
          barnum++;
        }
      });
      return arr;
    },
    customX() {
      let arr = [];
      switch (this.deleteRoI) {
        case "2":
          arr =
            this.listsortbycountry &&
            this.listsortbycountry.map((item) => item.geo);

          break;
        case "3":
          arr =
            this.listsortbyincome &&
            this.listsortbyincome.map((item) => item.mediaSource);

          break;
        case "4":
          arr =
            this.listsortbyincome &&
            this.listsortbyincome.map((item) => item.mediaSource);

          break;
        default:
          arr = this.list && this.list.map((item) => item.date);
      }

      return arr;
    },
  },
  methods: {
    reflashchart() {
      this.$nextTick(() => {
        this.$refs.normalchartsref && this.$refs.normalchartsref.reflashchart();
      });
    },
    changeshowview(val) {
      this.showview = val;
      this.$nextTick(() => {
        this.$refs.usertable && this.$refs.usertable.getTotalColumn();
      });
    },
    showLoading(value) {
      this.loading = value;
      this.$refs.usertable && this.$refs.usertable.refresh();
    },
    showLtvLoading(value) {
      this.ltvLoading = value;
      this.$refs.usertable && this.$refs.usertable.refresh();
    },
    changeColumn(value) {
      if (value == "2") {
        this.column = summary_country_table_column;
        // this.column[1].show = true;
        // this.column[0].show = false;
        // this.column[2].show = false;
      } else if (value == "1") {
        this.column = summary_date_table_column;
        // this.column[1].show = false;
        // this.column[0].show = true;
        // this.column[2].show = false;
      } else if (value == "3") {
        this.column = summary_medio_table_column;
        // this.column[1].show = false;
        // this.column[0].show = false;
        // this.column[2].show = true;
      } else if (value == "4") {
        this.column = summary_camp_table_column;
      }
      // this.$refs.usertable && this.$refs.usertable.changeHeigth(value);
      this.deleteRoI = value;
    },
    downloadFile() {
      this.$refs.usertable.downLoadFileToExcel();
    },
    refreshTable() {
      this.$refs.usertable && this.$refs.usertable.refresh();
    },
    computTotalColumn(arr) {
      this.totalColumn = arr;
    },
  },
  watch: {
    // deleteRoI: {
    //   handler(n) {
    //     switch (n) {
    //       case "country":
    //         this.customlist = this.listsortbycountry;
    //         break;
    //       case "mediaSource":
    //         this.customlist = this.listsortbyincome;
    //         break;
    //       default:
    //         this.customlist = this.list;
    //     }
    //   },
    //   immediate: true,
    // },
  },
};
</script>
<style lang="less">
.heaer-text {
  padding: 16px 16px 6px 16px;
  font-size: 15px;
  color: rgba(0, 0, 0, 0.85);
  font-weight: bold;
}
.table-wrap {
  padding: 15px;
}
</style>
